import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

// Owner completion of a persisted camera Media parent, with the ordinary Media
// Submit/Reopen placement. Completion is the parent's saved status only: it never
// stops a running camera (the permanent Camera control does), and an unconfirmed
// save says so while the feed reconciles the persisted status.
const reopenStyle = { background: 'transparent', border: 'none', color: '#6b7280', fontSize: '0.8rem', cursor: 'pointer', opacity: 0.7, padding: '4px 8px' };

export default function CameraMediaCompletion({ activity, mutation, onStatus }) {
  const done = activity.status === 'complete';
  const videos = Array.isArray(activity.data.videos) && activity.data.videos.length ? activity.data.videos : [activity.data.video];
  const capturing = videos.some(video => ['live', 'starting'].includes(video.state));
  const saving = mutation?.phase === 'saving';
  const run = () => onStatus(activity._id, done ? 'reopen' : 'complete');
  return (
    <div className="camera-media-completion">
      {!done && capturing && <p className="camera-media-completion-note">Marking complete does not stop the camera. Use the Camera control to stop.</p>}
      {mutation?.phase === 'unknown' && <p role="alert">Saving could not be confirmed. Showing the saved status. <button type="button" onClick={run}>Retry</button></p>}
      {mutation?.phase === 'rejected' && <p role="alert">{mutation.message}</p>}
      <div className="center-button pad-button-up-small">
        {done
          ? <button type="button" style={reopenStyle} disabled={saving} onClick={run}>{saving ? 'Saving…' : 'Reopen Media'}</button>
          : <button type="button" className="btn-select" disabled={saving} onClick={run}><CheckIcon className="icon" />{saving ? 'Saving…' : 'Mark complete'}</button>}
      </div>
    </div>
  );
}
